import React from 'react'
import './FlipCard.css'
const FlipCard = () => {
    return(
        <React.Fragment>
        <div classname="project">
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src="https://tse3.mm.bing.net/th?id=OIP.eGfcbgGGwcxclCumupu0UgHaHa&pid=Api&P=0&w=300&h=300" alt="avatar" style={{width: '250px', height: '250px'}}/>
                    </div>
                    <div className="flip-card-back">
                        <h1>Travenia</h1>
                        <p>Made with HTML, JS and Materialize CSS.<br/>
                        <a href="https://soham2020.github.io/travel/"><i className="fa fa-4px fa-github"></i></a></p>
                    </div>
                </div>
            </div>
            
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src="https://raw.githubusercontent.com/shubhamjha25/Portfolio-Website/master/src/images/p3.jpg" alt="avatar" style={{width: '250px', height: '250px'}}/>
                    </div>
                    <div className="flip-card-back">
                        <h1>Covid-19 Tracker</h1>
                        <p>Made with Rest API, JS, CHART.JS, HTML and CSS.<br/>
                        <a href="https://soham2020.github.io/tracker%20using%20js/"><i className="fa fa-4px fa-github"></i></a></p>
                    </div>
                </div>
            </div>
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src="https://raw.githubusercontent.com/shubhamjha25/Portfolio-Website/master/src/images/p4.jpg" alt="avatar" style={{width: '250px', height: '250px'}}/>
                    </div>
                    <div className="flip-card-back">
                        <h1>Dictionary App</h1>
                        <p>Made with Rest API, JS, HTML and CSS.<br/>
                        <a href="https://github.com/Soham2020/Dictionary"><i className="fa fa-4px fa-github"></i></a></p>
                    </div>
                </div>
            </div>
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src="https://raw.githubusercontent.com/shubhamjha25/Portfolio-Website/master/src/images/p1.png" alt="avatar" style={{width: '250px', height: '250px'}}/>
                    </div>
                    <div className="flip-card-back">
                        <h1>Tic-Tac-Toe</h1>
                        <p>Made in C.<br/>
                        <a href="https://github.com/Soham2020/TIC-TAC-TOE"><i className="fa fa-2px fa-github"></i></a></p>
                    </div>
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}
export default FlipCard